import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { GameProviderWithBannerListTableData } from '@/modules/game/type'
import ProviderListTable from '../ProviderListTable'
import DefaultProviderVersionCard from '../components/DefaultProviderVersionCard'

interface ProviderListListingProps {
	data: GameProviderWithBannerListTableData[]
	total: number
	isLoading: boolean
}

export default function ProviderListListing({
	data,
	total,
	isLoading,
}: ProviderListListingProps) {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading title={`รายชื่อค่ายเกม`} description="รายชื่อค่ายเกม" />
			</div>
			<Separator />
			<DefaultProviderVersionCard />

			<ProviderListTable data={data} total={total} isLoading={isLoading} />
		</div>
	)
}
